import { render, staticRenderFns } from "./FilterByCenso.vue?vue&type=template&id=4436636a&lang=pug&"
import script from "./FilterByCenso.vue?vue&type=script&lang=js&"
export * from "./FilterByCenso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports